import axios from "axios";

const API = (version = "v1") =>
  axios.create({
    baseURL: `https://insys.techlab.hphit.hutchisonports.com/workspace-backend/api/${version}/`,
  });

export default API();
